/**
 * MPS All Products Guide - Controller for Exact /collections/all
 * Minimal, fast, and robust e-commerce catalog hub.
 * Guaranteed ZERO REDIRECT - all filtering happens on the same page.
 */
(function () {
  'use strict';

  function isExactAllRoute() {
    var pathname = window.location.pathname.replace(/\/+$/, '');
    var parts = pathname.split('/').filter(Boolean);
    var allIdx = parts.indexOf('all');
    if (allIdx === -1) return false;
    if (allIdx === 0 || parts[allIdx - 1] !== 'collections') return false;
    if (parts.length > allIdx + 1) return false;
    return true;
  }

  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function handleize(str) {
    return normalize(str).replace(/\s+/g, '-');
  }

  function setOptions(select, options, defaultLabel) {
    if (!select) return;
    select.innerHTML = '';
    var defOpt = document.createElement('option');
    defOpt.value = '';
    defOpt.textContent = defaultLabel;
    select.appendChild(defOpt);

    options.forEach(function (opt) {
      var el = document.createElement('option');
      el.value = opt.value;
      el.textContent = opt.label;
      select.appendChild(el);
    });

    select.disabled = options.length === 0;
  }

  function cleanSectionElements(container) {
    if (!container) return;
    // .bike-finder-toolbar-wrapper / .filter-bike-selector: fetched bike-tag pages
    // render the native finder inside the results grid — strip it so only the
    // guide's own finder remains on this page (other pages are untouched).
    container.querySelectorAll('.bike-finder-toolbar-wrapper, .filter-bike-selector, .bike-result-seo, .main-products-grid__filters, .main-products-grid__filters--bike-results, .products-toolbar__filter, .promo-item, [data-search-ignore]').forEach(function (el) {
      el.remove();
    });
  }

  // Exhaustive Category Keyword Mappings for accurate bike availability detection
  var CATEGORY_KEYWORDS = {
    'termignoni-exhaust-systems': ['exhaust', 'silencer', 'muffler', 'header', 'full exhaust', 'de-cat', 'pipe', 'termignoni', 'ixil', 'ixrace', 'qd', 'arrow', 'leovince', 'ironhead'],
    'exhausts-spares': ['baffle', 'db killer', 'db-killer', 'bracket', 'clamp', 'spring', 'exhaust spare'],
    'performance-air-filters': ['air filter', 'filter', 'dna', 'intake', 'stage 2', 'stage 3'],
    'puig-motoplastics': ['screen', 'visor', 'windscreen', 'windshield', 'fairing', 'deflector', 'spoiler', 'fender extender', 'belly pan', 'puig'],
    'motorcycle-levers': ['lever', 'clutch lever', 'brake lever', 'levers'],
    'frame-sliders': ['slider', 'sliders', 'crash protection', 'protector', 'bobbin', 'spool', 'guard', 'engine cover'],
    'top-boxes': ['top box', 'top case', 'top master'],
    'shad-motorcycle-panniers': ['pannier', 'panniers', 'luggage', 'side case', 'shad', 'saddlebag'],
    'motorcycle-seat-covers': ['seat cover', 'seat covers', 'upholstery', 'tpz'],
    'paddock-stands': ['stand', 'paddock stand', 'paddock'],
    't800-upmap-performance-ecu': ['upmap', 't800', 'ecu', 'tuning', 'remap', 'cable'],
    'care-maintenance': ['cleaner', 'care', 'lube', 'spray', 'wash', 'bike-it']
  };

  function initGuide(root) {
    if (!root) return;
    if (!isExactAllRoute()) return;
    if (root.dataset.allGuideReady === 'true') return;
    root.dataset.allGuideReady = 'true';

    var form = root.querySelector('[data-all-guide-form]');
    var makeSelect = root.querySelector('[data-all-guide-make]');
    var modelSelect = root.querySelector('[data-all-guide-model]');
    var yearSelect = root.querySelector('[data-all-guide-year]');
    var submitBtn = root.querySelector('[data-all-guide-submit]');
    var submitText = root.querySelector('[data-all-guide-submit-text]');

    var filterPills = root.querySelector('[data-all-guide-pills]');
    var filterPillText = root.querySelector('[data-all-guide-pill-text]');
    var catCountEl = root.querySelector('[data-all-guide-cat-count]');
    var brandCountEl = root.querySelector('[data-all-guide-brand-count]');

    var activeBike = null;
    var activeCategory = null;
    var activeBrand = null;
    var bikeProductsHTML = '';
    var bikeToolbarHTML = '';
    var isLoading = false;

    var bikeData = Array.isArray(window.bikes) ? window.bikes : (typeof bikes !== 'undefined' ? bikes : []);
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!rootPath.endsWith('/')) rootPath += '/';

    // Locate the main products section & results container
    var productsSection = document.getElementById('shopify-section-collection-products') ||
                          document.querySelector('[id*="collection-products"]') ||
                          document.getElementById('filter-results');
    var resultsContainer = document.getElementById('filter-results') ||
                           document.querySelector('.main-products-grid__results') ||
                           productsSection;

    cleanSectionElements(productsSection);
    cleanSectionElements(resultsContainer);
    var initialProductsHTML = resultsContainer ? resultsContainer.innerHTML : '';

    var toolbarContainer = document.querySelector('.products-toolbar')
      ? document.querySelector('.products-toolbar').closest('.container')
      : null;
    cleanSectionElements(toolbarContainer);
    var initialToolbarHTML = toolbarContainer ? toolbarContainer.innerHTML : '';

    // =========================================================================
    // 1. ROBUST MAKE, MODEL & YEAR POPULATION (FIXES MT-09 & ALL HYPHEN MODELS)
    // =========================================================================
    function populateMakes() {
      if (!makeSelect) return;
      var seen = {};
      var makes = [];

      bikeData.forEach(function (b) {
        if (!b.make || seen[b.make]) return;
        seen[b.make] = true;
        makes.push({ value: b.make, label: b.make });
      });

      makes.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });

      setOptions(makeSelect, makes, 'Select Make...');
      setOptions(modelSelect, [], 'Select Model...');
      setOptions(yearSelect, [], 'Select Year...');
      if (submitBtn) submitBtn.disabled = true;
    }

    function populateModels(targetModel) {
      if (!makeSelect || !modelSelect) return;
      var currentMake = makeSelect.value.trim().toLowerCase();
      var currentMakeNormalized = normalize(currentMake);
      var seen = {};
      var models = [];

      bikeData.forEach(function (b) {
        if (b.make.trim().toLowerCase() !== currentMake && normalize(b.make) !== currentMakeNormalized) return;
        if (Array.isArray(b.models)) {
          b.models.forEach(function (m) {
            var modelName = (typeof m === 'string' ? m : m.model).trim();
            if (modelName && !seen[modelName]) {
              seen[modelName] = true;
              models.push({ value: modelName, label: modelName });
            }
          });
        }
      });

      models.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });

      setOptions(modelSelect, models, 'Select Model...');
      if (targetModel) modelSelect.value = targetModel;
      setOptions(yearSelect, [], 'Select Year...');
      if (submitBtn) submitBtn.disabled = true;
    }

    function populateYears(targetYear) {
      if (!makeSelect || !modelSelect || !yearSelect) return;
      var currentMake = makeSelect.value.trim().toLowerCase();
      var currentMakeNormalized = normalize(currentMake);
      var currentModel = modelSelect.value.trim().toLowerCase();
      var currentModelNormalized = normalize(currentModel);
      var seen = {};
      var years = [];

      bikeData.forEach(function (b) {
        if (b.make.trim().toLowerCase() !== currentMake && normalize(b.make) !== currentMakeNormalized) return;
        if (Array.isArray(b.models)) {
          b.models.forEach(function (m) {
            var modelName = (typeof m === 'string' ? m : m.model).trim();
            var mNameLower = modelName.toLowerCase();
            // Robust match: exact string compare OR normalized compare
            if ((mNameLower === currentModel || normalize(modelName) === currentModelNormalized) && Array.isArray(m.years)) {
              m.years.forEach(function (y) {
                var yStr = String(y).trim();
                if (yStr && !seen[yStr]) {
                  seen[yStr] = true;
                  years.push({ value: yStr, label: yStr });
                }
              });
            }
          });
        }
      });

      years.sort(function (a, b) {
        return Number(b.value) - Number(a.value);
      });

      setOptions(yearSelect, years, 'Select Year...');
      if (targetYear) yearSelect.value = targetYear;
      if (submitBtn) submitBtn.disabled = !yearSelect.value;
    }

    if (makeSelect) {
      makeSelect.addEventListener('change', function () {
        populateModels();
      });
    }

    if (modelSelect) {
      modelSelect.addEventListener('change', function () {
        populateYears();
      });
    }

    if (yearSelect) {
      yearSelect.addEventListener('change', function () {
        if (submitBtn) {
          submitBtn.disabled = !makeSelect.value || !modelSelect.value || !yearSelect.value;
        }
      });
    }

    // =========================================================================
    // 2. DYNAMIC AVAILABILITY FILTERING (ONLY SHOW AVAILABLE FOR CHOSEN BIKE)
    // =========================================================================
    function updateAvailabilityForBike(container) {
      if (!container) return;

      var productItems = container.querySelectorAll('.card, [data-search-item], li.slider__item, .product-card');
      var vendors = {};
      var searchTexts = [];

      productItems.forEach(function (item) {
        var v = (item.getAttribute('data-vendor') || '').toLowerCase().trim();
        if (v) vendors[v] = true;
        var st = (item.getAttribute('data-search-text') || item.textContent || '').toLowerCase();
        searchTexts.push(st);
      });

      // Filter Brands Showcase: Show ONLY brands that have products
      var visibleBrandCount = 0;
      var totalBrands = 0;
      root.querySelectorAll('[data-brand-card]').forEach(function (card) {
        totalBrands++;
        var bName = (card.getAttribute('data-brand-name') || '').toLowerCase().trim();
        var bHandle = (card.getAttribute('data-brand-handle') || '').toLowerCase().trim();
        var bFirstWord = bName.split(' ')[0];

        var isAvailable = false;
        Object.keys(vendors).forEach(function (vendor) {
          if (!isAvailable && (vendor.indexOf(bFirstWord) !== -1 || bName.indexOf(vendor) !== -1)) {
            isAvailable = true;
          }
        });

        if (!isAvailable) {
          for (var i = 0; i < searchTexts.length; i++) {
            if (searchTexts[i].indexOf(bName) !== -1 || (bHandle && searchTexts[i].indexOf(bHandle) !== -1)) {
              isAvailable = true;
              break;
            }
          }
        }

        if (isAvailable) {
          card.style.display = '';
          visibleBrandCount++;
        } else {
          card.style.display = 'none'; // Cleanly hide, no shading
        }
      });

      if (brandCountEl) {
        brandCountEl.textContent = '(' + visibleBrandCount + ' available)';
      }

      // Filter Categories Showcase: Show ONLY categories that have products
      var visibleCatCount = 0;
      var totalCats = 0;
      root.querySelectorAll('[data-category-card]').forEach(function (card) {
        totalCats++;
        var catName = (card.getAttribute('data-category-name') || '').toLowerCase().trim();
        var catHandle = (card.getAttribute('data-category-handle') || '').toLowerCase().trim();
        var keywords = CATEGORY_KEYWORDS[catHandle] || [catName, catHandle.replace(/-/g, ' ')];

        var isAvailable = false;
        for (var i = 0; i < searchTexts.length; i++) {
          var text = searchTexts[i];
          for (var k = 0; k < keywords.length; k++) {
            if (text.indexOf(keywords[k]) !== -1) {
              isAvailable = true;
              break;
            }
          }
          if (isAvailable) break;
        }

        if (isAvailable) {
          card.style.display = '';
          visibleCatCount++;
        } else {
          card.style.display = 'none'; // Cleanly hide, no shading
        }
      });

      if (catCountEl) {
        catCountEl.textContent = '(' + visibleCatCount + ' available)';
      }
    }

    function resetAvailabilityToShowAll() {
      root.querySelectorAll('[data-brand-card], [data-category-card]').forEach(function (card) {
        card.style.display = '';
        card.classList.remove('all-guide-card--selected');
      });
      if (catCountEl) catCountEl.textContent = '';
      if (brandCountEl) brandCountEl.textContent = '';
    }

    function deselectShowcaseCards() {
      root.querySelectorAll('[data-brand-card], [data-category-card]').forEach(function (card) {
        card.classList.remove('all-guide-card--selected');
      });
    }

    function hideFilterPills() {
      if (filterPills) {
        filterPills.hidden = true;
        filterPills.classList.remove('all-guide-filter-pills--error');
      }
      if (filterPillText) filterPillText.textContent = '';
    }

    function showFilterPills(typeText, valueText) {
      if (!filterPills) return;
      if (filterPillText) filterPillText.textContent = valueText;
      filterPills.hidden = false;
    }

    function showErrorPill(message) {
      if (!filterPills) return;
      if (filterPillText) filterPillText.textContent = message;
      filterPills.classList.add('all-guide-filter-pills--error');
      filterPills.hidden = false;
      setTimeout(function () {
        filterPills.classList.remove('all-guide-filter-pills--error');
        if (filterPillText.textContent === message) hideFilterPills();
      }, 5000);
    }

    // Shared matcher: brand cards match by vendor/title, category cards by keyword map.
    // Keeps in-page filtering consistent with the showcase availability logic.
    function itemMatchesFilter(item, filter, type) {
      var text = (item.getAttribute('data-search-text') || item.textContent || '').toLowerCase();
      if (type === 'brand') {
        var name = filter.name.toLowerCase().trim();
        var vendor = (item.getAttribute('data-vendor') || '').toLowerCase().trim();
        var firstWord = name.split(' ')[0];
        if (vendor && (vendor.indexOf(firstWord) !== -1 || name.indexOf(vendor) !== -1)) return true;
        return text.indexOf(name) !== -1 || (!!filter.handle && text.indexOf(filter.handle) !== -1);
      }
      var handle = (filter.handle || '').toLowerCase().trim();
      var keywords = CATEGORY_KEYWORDS[handle] || [filter.name.toLowerCase().trim(), handle.replace(/-/g, ' ')];
      for (var k = 0; k < keywords.length; k++) {
        if (keywords[k] && text.indexOf(keywords[k]) !== -1) return true;
      }
      return false;
    }

    function clearEmptyState() {
      if (!resultsContainer) return;
      var existing = resultsContainer.querySelector('.all-guide-empty-state');
      if (existing) existing.remove();
    }

    function showEmptyState(filter, type) {
      if (!resultsContainer) return;
      var el = document.createElement('div');
      el.className = 'all-guide-empty-state';
      var safeName = String(filter.name).replace(/[<>&"]/g, '');
      el.innerHTML = '<p class="all-guide-empty-state__title">No matching parts found</p>' +
        '<p class="all-guide-empty-state__text">No ' + type + ' products matching &ldquo;' + safeName + '&rdquo; were found for this bike. ' +
        '<button type="button" class="all-guide-empty-state__clear" data-all-guide-pill-clear>Clear this filter</button> to see all compatible parts.</p>';
      resultsContainer.appendChild(el);
    }

    // Filter products within the currently active bike results in-place
    function filterBikeProductsInPage() {
      if (!resultsContainer || !bikeProductsHTML) return;

      var filter = activeCategory || activeBrand;
      var type = activeCategory ? 'category' : 'brand';

      // Always restore the full bike result set first, then narrow it down
      resultsContainer.innerHTML = bikeProductsHTML;
      cleanSectionElements(resultsContainer);
      clearEmptyState();

      if (!filter) return;

      showFilterPills(type === 'category' ? 'Category' : 'Brand', filter.name);

      var items = resultsContainer.querySelectorAll('.card, [data-search-item], li.slider__item, .product-card');
      var visible = 0;
      items.forEach(function (item) {
        var matched = itemMatchesFilter(item, filter, type);
        item.style.display = matched ? '' : 'none';
        if (matched) visible++;
      });

      if (visible === 0) showEmptyState(filter, type);
    }

    // Load category or brand collection on the same page via AJAX (when NO bike is selected)
    function loadCollectionOnSamePage(fetchUrl, title, filterType) {
      if (!fetchUrl || fetchUrl === '#' || fetchUrl === '/') return;
      if (!resultsContainer || isLoading) return;

      isLoading = true;
      showFilterPills(filterType, title + ' …');
      if (resultsContainer) resultsContainer.classList.add('is-loading');

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Status: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newProductsSection = doc.getElementById('shopify-section-collection-products') ||
                                   doc.querySelector('[id*="collection-products"]') ||
                                   doc.getElementById('filter-results');
          var newResults = doc.getElementById('filter-results') ||
                           doc.querySelector('.main-products-grid__results') ||
                           newProductsSection;

          var newToolbar = doc.querySelector('.products-toolbar')
            ? doc.querySelector('.products-toolbar').closest('.container')
            : null;

          cleanSectionElements(newResults);
          cleanSectionElements(newToolbar);

          if (resultsContainer && newResults) {
            resultsContainer.innerHTML = newResults.innerHTML;
          }

          if (toolbarContainer && newToolbar) {
            toolbarContainer.innerHTML = newToolbar.innerHTML;
          }

          root.querySelectorAll('[data-all-guide-reset]').forEach(function (btn) {
            btn.hidden = false;
          });

          showFilterPills(filterType, title);

          // Scroll only as far as the showcase, so "Shop by Category" and
          // "Top Performance Brands" stay on screen above the product grid.
          var scrollAnchor = root.querySelector('[data-all-guide-showcase]') ||
                             document.getElementById('all-products-catalog') ||
                             resultsContainer;
          if (scrollAnchor) {
            scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          if (resultsContainer) resultsContainer.classList.remove('is-loading');

          document.dispatchEvent(new CustomEvent('shopify:section:load', {
            target: resultsContainer
          }));
        })
        .catch(function () {
          // Stay on page, zero redirect — but tell the user it failed
          hideFilterPills();
          showErrorPill("Couldn't load that collection. Please try again.");
          if (resultsContainer) resultsContainer.classList.remove('is-loading');
        })
        .then(function () {
          isLoading = false;
        });
    }

    // In-Page Bike Filter Application (ZERO REDIRECT)
    function applyBikeFilterOnSamePage(make, model, year) {
      if (!make || !model || !year || isLoading) return;

      var bikeLabel = make + ' ' + model + ' ' + year;
      var tagHandle = [make, model, year].map(handleize).join('-');
      var targetUrl = rootPath + 'collections/all/' + tagHandle;

      activeBike = {
        make: make,
        model: model,
        year: year,
        tagHandle: tagHandle,
        label: bikeLabel
      };
      activeBrand = null;
      activeCategory = null;
      deselectShowcaseCards();
      hideFilterPills();

      var payload = {
        make: make,
        model: model,
        year: year,
        tagHandle: tagHandle,
        searchTerms: [bikeLabel, make, model, year]
      };

      try {
        localStorage.setItem('sj_selected_vehicle', JSON.stringify(payload));
      } catch (err) {}

      document.dispatchEvent(new CustomEvent('global-fitment-selected', {
        detail: payload
      }));

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('all-guide-btn-submit--loading');
        if (submitText) submitText.textContent = 'Searching...';
      }

      // Theme's own loading treatment: grid fades out + spinner
      if (resultsContainer) resultsContainer.classList.add('is-loading');

      fetch(targetUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Network error: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newProductsSection = doc.getElementById('shopify-section-collection-products') ||
                                   doc.querySelector('[id*="collection-products"]') ||
                                   doc.getElementById('filter-results');
          var newResults = doc.getElementById('filter-results') ||
                           doc.querySelector('.main-products-grid__results') ||
                           newProductsSection;

          var newToolbar = doc.querySelector('.products-toolbar')
            ? doc.querySelector('.products-toolbar').closest('.container')
            : null;

          cleanSectionElements(newResults);
          cleanSectionElements(newToolbar);

          if (resultsContainer && newResults) {
            bikeProductsHTML = newResults.innerHTML;
            resultsContainer.innerHTML = bikeProductsHTML;
          }

          if (toolbarContainer && newToolbar) {
            bikeToolbarHTML = newToolbar.innerHTML;
            toolbarContainer.innerHTML = bikeToolbarHTML;
          }

          // Dynamically filter Categories & Brands to ONLY show what is available for this bike
          if (newResults) {
            updateAvailabilityForBike(newResults);
          }

          root.querySelectorAll('[data-all-guide-reset]').forEach(function (btn) {
            btn.hidden = false;
          });

          try {
            history.pushState({ bike: tagHandle, bikeLabel: bikeLabel, make: make, model: model, year: year }, '', targetUrl);
          } catch (e) {}

          // Scroll only as far as the showcase, so "Shop by Category" and
          // "Top Performance Brands" stay on screen above the product grid.
          var scrollAnchor = root.querySelector('[data-all-guide-showcase]') ||
                             document.getElementById('all-products-catalog') ||
                             resultsContainer;
          if (scrollAnchor) {
            scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('all-guide-btn-submit--loading');
            if (submitText) submitText.textContent = 'Update Parts';
          }

          if (resultsContainer) resultsContainer.classList.remove('is-loading');

          isLoading = false;

          document.dispatchEvent(new CustomEvent('shopify:section:load', {
            target: resultsContainer
          }));
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('all-guide-btn-submit--loading');
            if (submitText) submitText.textContent = 'Try Again';
          }
          if (resultsContainer) resultsContainer.classList.remove('is-loading');
          isLoading = false;
        });
    }

    // Reset to full catalog
    function resetToAllProducts() {
      activeBike = null;
      activeBrand = null;
      activeCategory = null;
      bikeProductsHTML = '';
      bikeToolbarHTML = '';

      if (makeSelect) makeSelect.value = '';
      setOptions(modelSelect, [], 'Select Model...');
      setOptions(yearSelect, [], 'Select Year...');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.remove('all-guide-btn-submit--loading');
        if (submitText) submitText.textContent = 'Find Parts';
      }

      root.querySelectorAll('[data-all-guide-reset]').forEach(function (btn) {
        btn.hidden = true;
      });

      hideFilterPills();

      // Show all categories & brands again
      resetAvailabilityToShowAll();

      if (resultsContainer && initialProductsHTML) {
        resultsContainer.innerHTML = initialProductsHTML;
      }

      if (toolbarContainer && initialToolbarHTML) {
        toolbarContainer.innerHTML = initialToolbarHTML;
      }

      try {
        history.pushState({}, '', rootPath + 'collections/all');
        localStorage.removeItem('sj_selected_vehicle');
      } catch (e) {}

      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        target: resultsContainer
      }));
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var make = makeSelect ? makeSelect.value.trim() : '';
        var model = modelSelect ? modelSelect.value.trim() : '';
        var year = yearSelect ? yearSelect.value.trim() : '';
        if (!make || !model || !year) return;

        applyBikeFilterOnSamePage(make, model, year);
      });
    }

    window.addEventListener('popstate', function (event) {
      if (event.state && event.state.make && event.state.model && event.state.year) {
        if (makeSelect) makeSelect.value = event.state.make;
        populateModels(event.state.model);
        populateYears(event.state.year);
        applyBikeFilterOnSamePage(event.state.make, event.state.model, event.state.year);
      } else if (isExactAllRoute()) {
        resetToAllProducts();
      }
    });

    populateMakes();

    // =========================================================================
    // 3. GLOBAL DOCUMENT EVENT DELEGATION (GUARANTEED ZERO REDIRECT)
    // =========================================================================
    document.addEventListener('click', function (e) {
      // Category Card Click
      var catCard = e.target.closest('[data-category-card]');
      if (catCard) {
        e.preventDefault();
        var catUrl = catCard.getAttribute('href');
        var catHandle = catCard.getAttribute('data-category-handle') || '';
        var catName = catCard.getAttribute('data-category-name') || catCard.getAttribute('title') || 'Category';

        if (catCard.classList.contains('all-guide-card--selected')) {
          deselectShowcaseCards();
          activeCategory = null;
          hideFilterPills();
          if (activeBike) {
            filterBikeProductsInPage();
          } else {
            resetToAllProducts();
          }
          return;
        }

        deselectShowcaseCards();
        catCard.classList.add('all-guide-card--selected');
        activeCategory = { name: catName, handle: catHandle, url: catUrl };
        activeBrand = null;

        if (activeBike) {
          filterBikeProductsInPage();
        } else {
          loadCollectionOnSamePage(catUrl, catName, 'Category');
        }
        return;
      }

      // Brand Card Click
      var brandCard = e.target.closest('[data-brand-card]');
      if (brandCard) {
        e.preventDefault();
        var brandUrl = brandCard.getAttribute('href');
        var brandHandle = brandCard.getAttribute('data-brand-handle') || '';
        var brandName = brandCard.getAttribute('data-brand-name') || brandCard.getAttribute('title') || 'Brand';

        if (brandCard.classList.contains('all-guide-card--selected')) {
          deselectShowcaseCards();
          activeBrand = null;
          hideFilterPills();
          if (activeBike) {
            filterBikeProductsInPage();
          } else {
            resetToAllProducts();
          }
          return;
        }

        deselectShowcaseCards();
        brandCard.classList.add('all-guide-card--selected');
        activeBrand = { name: brandName, handle: brandHandle, url: brandUrl };
        activeCategory = null;

        if (activeBike) {
          filterBikeProductsInPage();
        } else {
          loadCollectionOnSamePage(brandUrl, brandName + ' Products', 'Brand');
        }
        return;
      }

      // Reset / Clear Button Click
      var resetBtn = e.target.closest('[data-all-guide-reset]');
      if (resetBtn) {
        e.preventDefault();
        resetToAllProducts();
        return;
      }

      // Filter Pill Clear Button Click
      var pillClear = e.target.closest('[data-all-guide-pill-clear]');
      if (pillClear) {
        e.preventDefault();
        deselectShowcaseCards();
        activeBrand = null;
        activeCategory = null;
        hideFilterPills();
        if (activeBike) {
          filterBikeProductsInPage();
        } else {
          resetToAllProducts();
        }
        return;
      }
    }, true);
  }

  // Older finder links used /collections/all?bike=<make-model-year>, which the
  // store cannot filter. Send them to the real bike results page instead.
  function redirectLegacyBikeUrl() {
    if (!isExactAllRoute() || !window.URLSearchParams) return false;
    var bike = new URLSearchParams(window.location.search).get('bike');
    if (!bike || !/^[a-z0-9-]+$/i.test(bike)) return false;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    window.location.replace(root + 'collections/all/' + bike.toLowerCase());
    return true;
  }

  if (redirectLegacyBikeUrl()) return;

  function setup() {
    var root = document.querySelector('[data-all-products-guide]');
    if (root) {
      initGuide(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { (window.mpsOnBikes || function (fn) { fn(); })(setup); });
  } else {
    (window.mpsOnBikes || function (fn) { fn(); })(setup);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-all-products-guide]')) {
      setup();
    }
  });
})();
